// @flow
/** @jsx isolateComponent */

import { Colors, Typography } from '@zapier/design-system/src/theme';
import { isolateComponent, labelStyles } from '@zapier/common-utils';

import { type Node } from 'react';

type Props = {|
  /**
   * The content to render.
   */
  children: Node,
|};

const Styles = labelStyles(__filename, {
  root: {
    ...Typography.base,
    color: Colors.grey700,
    fontSize: 12,
    fontWeight: 400,
    textTransform: 'lowercase',
    '&::before': {
      content: '"("',
    },
    '&::after': {
      content: '")"',
    },
  },
});

/**
 * `FormLabelRequiredText` indicates whether a field is required.
 * Should always be a descendant of a `Label`.
 *
 * Tags: core-ui, forms
 */
const FormLabelRequiredText = (props: Props) => (
  // `aria-hidden` to prevent it from being read redundantly.
  // The associated `input` field should indicate whether it's
  // required to screenreaders.
  <span aria-hidden="true" css={Styles.root}>
    {props.children}
  </span>
);

FormLabelRequiredText.defaultProps = {
  children: 'Required',
};

export default FormLabelRequiredText;
